import React from 'react'
import _ from 'lodash'

import {Steps} from 'antd'

import {Grid, Row, Col} from 'react-flexbox-grid'

import {DevicesStorage} from 'storage'

import {CreateNetwork} from './CreateNetwork'
import {CreateGateway} from './CreateGateway'
import {Connection} from './Connection'

const WrappedSetupGuide = ({network, networks, devices, embedded, Sidebar, ...props}) => {
   let step, Child

   const noNetworks = 0 === _.size(networks),
      firstNetwork = noNetworks || 1 === _.size(networks)

   if (undefined === network.devices) {
      step = 0
      Child = CreateNetwork
   } else if (undefined === _.find(devices, {type: 'gateway'})) {
      step = 1
      Child = CreateGateway
   } else {
      step = 2
      Child = Connection
   }

   // network := undefined -> embedded
   if (true === embedded) {
      return (
         <div>
            <SetupSteps network={network} step={step} />
            <Child network={network} {...props} />
         </div>
      )
   } else {
      return (
         <div className="no-menu">
            <Grid>
               <Row>
                  {!firstNetwork
                     ? <Col xs={4}>
                          <Sidebar nid={network ? network.key : null} {...props} />
                       </Col>
                     : null}

                  <Col xs={firstNetwork ? 12 : 8}>
                     <SetupSteps network={network} step={step} />
                     <Child network={network} {...props} />
                  </Col>
               </Row>
            </Grid>
         </div>
      )
   }
}

WrappedSetupGuide.propTypes = {
   network:  React.PropTypes.object.isRequired,
   networks: React.PropTypes.array.isRequired,
   devices:  React.PropTypes.array.isRequired,
   Sidebar:  React.PropTypes.any,
   embedded: React.PropTypes.bool
}

WrappedSetupGuide.defaultProps = {
   devices: [],
   network: {}
}

export const SetupGuide = ({network, ...props}) => {
   return network
      ? <DevicesStorage nid={network.key}>
           <WrappedSetupGuide network={network} {...props} />
        </DevicesStorage>
      : <WrappedSetupGuide network={network} devices={[]} {...props} />
}

SetupGuide.propTypes = {
   network: React.PropTypes.object.isRequired,
   routes:  React.PropTypes.array.isRequired,
   router:  React.PropTypes.object.isRequired
}

SetupGuide.setupFinished = ({channels, key}) => {
   if (undefined === localStorage['skip-setup#' + key]) {
      return 0 !== channels.length
   } else {
      return 'true' === localStorage['skip-setup#' + key]
   }
}

SetupGuide.skipSetup = ({key}) => {
   localStorage['skip-setup#' + key] = 'true'
}

const networkName = network => _.get(network, 'name', undefined) || 'Unnamed Network'
const hasDevices = network => 0 < _.get(network, 'devices', []).length

export const SetupSteps = ({network, step}) => (
   <Steps current={step || 0}>
      <Steps.Step
         title={
            _.get(network, 'key', false) ? 'Network: ' + networkName(network) : 'Create New Network'
         }
      />
      <Steps.Step title={hasDevices(network) ? 'Gateway Created' : 'Create New Gateway'} />
      <Steps.Step title="Connect Your Gateway" />
      <Steps.Step title="Get Started" />
   </Steps>
)

SetupSteps.propTypes = {
   step:    React.PropTypes.number,
   network: React.PropTypes.object
}

SetupGuide.childRoutes = [
   {
      path:      ':nid',
      component: SetupGuide
   }
]



// WEBPACK FOOTER //
// lib/bundle/dashboard/setup-guide/index.js